import type { SVGProps } from "react";

const CyberEssentials = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 416.92812 499.89168"
    {...props}
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="208.46406"
        y1="0"
        x2="208.46406"
        y2="499.89168"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          stopColor="#0376ae"
        />
        <stop
          offset="1"
          stopColor="#22305e"
        />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="78.27839"
        y1="309.96521"
        x2="178.55948"
        y2="309.96521"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          stopColor="#8bc057"
        />
        <stop
          offset="1"
          stopColor="#2d7531"
        />
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        x1="141.39802"
        y1="267.53048"
        x2="347.24152"
        y2="267.53048"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0"
          stopColor="#70c6f0"
        />
        <stop
          offset="1"
          stopColor="#1f65a8"
        />
      </linearGradient>
    </defs>
    <path
      d="M208.46385,0h.00042C323.5186,0,416.92812,93.40952,416.92812,208.46385v268.62369c0,12.58595-10.21819,22.80414-22.80414,22.80414H22.80414C10.21819,499.89168,0,489.67349,0,477.08754V208.46385C0,93.40952,93.40952,0,208.46385,0Z"
      fill="url(#linear-gradient)"
      strokeWidth={0}
    />
    <path
      d="M78.27839,248.5167s.41182,59.16883,64.14,122.89701l36.14109-122.89701s-17.69454,26.72984-48.56461,26.72984-51.71648-26.72984-51.71648-26.72984Z"
      fill="url(#linear-gradient-2)"
      strokeWidth={0}
    />
    <g>
      <path
        d="M47.97985,143.87846v-41.47998h27.82227v7.01709h-20.24561v9.1958h18.83789v6.98877h-18.83789v11.28955h20.9624v6.98877h-28.53906Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M81.02379,130.38188l7.37158-.79199c.44336,2.73535,1.34375,4.74414,2.7002,6.02637,1.35645,1.2832,3.18652,1.92432,5.49023,1.92432,2.43994,0,4.27832-.57031,5.51562-1.71191,1.2373-1.14111,1.85596-2.47559,1.85596-4.00391,0-.98047-.26074-1.81494-.78076-2.50391-.521-.68848-1.4292-1.28711-2.72607-1.79688-.88721-.33936-2.90918-.94287-6.06592-1.81055-4.06152-1.11279-6.91064-2.48047-8.54883-4.10254-2.30371-2.28223-3.45557-5.06494-3.45557-8.34717,0-2.1123.5415-4.08838,1.62549-5.92773,1.0835-1.83887,2.64453-3.23975,4.68408-4.20166,2.03857-.96191,4.5-1.44287,7.38379-1.44287,4.70996,0,8.25488,1.14111,10.63525,3.42334,2.38037,2.28271,3.62988,5.3291,3.74951,9.13916l-7.57617.36816c-.32422-2.13184-1.02002-3.66455-2.08594-4.59814-1.06689-.93359-2.6665-1.40039-4.79932-1.40039-2.20117,0-3.9248.5-5.16992,1.49951-.80225.6416-1.20312,1.49951-1.20312,2.57471,0,.98096.375,1.8208,1.12598,2.51807.95557.88721,3.27637,1.81104,6.96191,2.77295,3.68604.96191,6.41162,1.95752,8.17773,2.98535,1.76611,1.02832,3.14844,2.43311,4.14648,4.21582s1.49756,3.98486,1.49756,6.60693c0,2.37646-.59766,4.60254-1.79199,6.67725-1.19434,2.0752-2.88379,3.61719-5.06787,4.62598-2.18408,1.00928-4.90576,1.51416-8.16455,1.51416-4.74414,0-8.38721-1.21191-10.9292-3.63623-2.54297-2.42334-4.06152-5.95557-4.55615-10.59619Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M114.93834,130.38188l7.37158-.79199c.44336,2.73535,1.34375,4.74414,2.7002,6.02637,1.35645,1.2832,3.18652,1.92432,5.49023,1.92432,2.43994,0,4.27832-.57031,5.51562-1.71191,1.2373-1.14111,1.85596-2.47559,1.85596-4.00391,0-.98047-.26074-1.81494-.78076-2.50391-.521-.68848-1.4292-1.28711-2.72607-1.79688-.88721-.33936-2.90918-.94287-6.06592-1.81055-4.06152-1.11279-6.91064-2.48047-8.54883-4.10254-2.30371-2.28223-3.45557-5.06494-3.45557-8.34717,0-2.1123.5415-4.08838,1.62549-5.92773,1.0835-1.83887,2.64453-3.23975,4.68408-4.20166,2.03857-.96191,4.5-1.44287,7.38379-1.44287,4.70996,0,8.25488,1.14111,10.63525,3.42334,2.38037,2.28271,3.62988,5.3291,3.74951,9.13916l-7.57617.36816c-.32422-2.13184-1.02002-3.66455-2.08594-4.59814-1.06689-.93359-2.6665-1.40039-4.79932-1.40039-2.20117,0-3.9248.5-5.16992,1.49951-.80225.6416-1.20312,1.49951-1.20312,2.57471,0,.98096.375,1.8208,1.12598,2.51807.95557.88721,3.27637,1.81104,6.96191,2.77295,3.68604.96191,6.41162,1.95752,8.17773,2.98535,1.76611,1.02832,3.14844,2.43311,4.14648,4.21582s1.49756,3.98486,1.49756,6.60693c0,2.37646-.59766,4.60254-1.79199,6.67725-1.19434,2.0752-2.88379,3.61719-5.06787,4.62598-2.18408,1.00928-4.90576,1.51416-8.16455,1.51416-4.74414,0-8.38721-1.21191-10.9292-3.63623-2.54297-2.42334-4.06152-5.95557-4.55615-10.59619Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M150.77282,143.87846v-41.47998h27.82227v7.01709h-20.24561v9.1958h18.83789v6.98877h-18.83789v11.28955h20.9624v6.98877h-28.53906Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M185.81285,143.87846v-41.47998h7.37109l15.35742,27.70068v-27.70068h7.03857v41.47998h-7.60156l-15.12695-27.0498v27.0498h-7.03857Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M233.08629,143.87846v-34.46289h-11.13428v-7.01709h29.81885v7.01709h-11.1084v34.46289h-7.57617Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M257.47789,143.87846v-41.47998h7.57617v41.47998h-7.57617Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M307.15709,143.87846h-8.2417l-3.27637-9.42188h-14.99902l-3.09668,9.42188h-8.03711l14.61475-41.47998h8.01172l15.02441,41.47998ZM293.20739,127.46782l-5.17041-15.39258-5.06787,15.39258h10.23828Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M311.38024,143.87846v-41.14014h7.57617v34.15137h18.83789v6.98877h-26.41406Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M341.27575,130.38188l7.37158-.79199c.44336,2.73535,1.34375,4.74414,2.7002,6.02637,1.35645,1.2832,3.18652,1.92432,5.49023,1.92432,2.43994,0,4.27832-.57031,5.51562-1.71191,1.2373-1.14111,1.85596-2.47559,1.85596-4.00391,0-.98047-.26074-1.81494-.78076-2.50391-.521-.68848-1.4292-1.28711-2.72607-1.79688-.88721-.33936-2.90918-.94287-6.06592-1.81055-4.06152-1.11279-6.91064-2.48047-8.54883-4.10254-2.30371-2.28223-3.45557-5.06494-3.45557-8.34717,0-2.1123.5415-4.08838,1.62549-5.92773,1.0835-1.83887,2.64453-3.23975,4.68408-4.20166,2.03857-.96191,4.5-1.44287,7.38379-1.44287,4.70996,0,8.25488,1.14111,10.63525,3.42334,2.38037,2.28271,3.62988,5.3291,3.74951,9.13916l-7.57617.36816c-.32422-2.13184-1.02002-3.66455-2.08594-4.59814-1.06689-.93359-2.6665-1.40039-4.79932-1.40039-2.20117,0-3.9248.5-5.16992,1.49951-.80225.6416-1.20312,1.49951-1.20312,2.57471,0,.98096.375,1.8208,1.12598,2.51807.95557.88721,3.27637,1.81104,6.96191,2.77295,3.68604.96191,6.41162,1.95752,8.17773,2.98535,1.76611,1.02832,3.14844,2.43311,4.14648,4.21582s1.49756,3.98486,1.49756,6.60693c0,2.37646-.59766,4.60254-1.79199,6.67725-1.19434,2.0752-2.88379,3.61719-5.06787,4.62598-2.18408,1.00928-4.90576,1.51416-8.16455,1.51416-4.74414,0-8.38721-1.21191-10.9292-3.63623-2.54297-2.42334-4.06152-5.95557-4.55615-10.59619Z"
        fill="#fff"
        strokeWidth={0}
      />
    </g>
    <g>
      <path
        d="M145.02379,78.18071l7.3457,2.5752c-1.12598,4.52686-2.99902,7.88965-5.61816,10.08691-2.61963,2.19775-5.94238,3.29639-9.96924,3.29639-4.98291,0-9.07812-1.88184-12.28613-5.64502s-4.81152-8.90771-4.81152-15.43457c0-6.90381,1.6123-12.26562,4.8374-16.08545s7.46484-5.72949,12.7207-5.72949c4.58984,0,8.31836,1.49951,11.18506,4.49854,1.70605,1.77344,2.98584,4.31982,3.83936,7.63965l-7.49951,1.98047c-.44385-2.15039-1.36914-3.84766-2.77686-5.09277s-3.11865-1.86768-5.13184-1.86768c-2.78174,0-5.03809,1.10352-6.77002,3.31055s-2.59766,5.78174-2.59766,10.72363c0,5.24414.85303,8.979,2.55908,11.20459,1.70605,2.22607,3.9248,3.33887,6.65479,3.33887,2.01367,0,3.74561-.70752,5.1958-2.12207s2.49121-3.64014,3.12305-6.67773Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M168.72496,93.43169v-17.45752l-13.74463-24.02246h8.88135l8.83057,16.41113,8.65088-16.41113h8.72803l-13.7959,24.07861v17.40137h-7.55029Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M193.85973,51.9517h14.99902c2.96875,0,5.18262.13721,6.6416.41064s2.76465.84424,3.91602,1.71143c1.15186.86816,2.11182,2.02344,2.87988,3.46631.76758,1.44287,1.15137,3.06055,1.15137,4.85254,0,1.94287-.47314,3.72559-1.42041,5.34766-.94678,1.62256-2.23096,2.83936-3.85205,3.6499,2.28662.73584,4.04395,1.99023,5.27246,3.76318,1.229,1.77344,1.84326,3.85791,1.84326,6.25293,0,1.88672-.39697,3.7207-1.19043,5.50342s-1.87695,3.20703-3.25049,4.27246c-1.37402,1.06592-3.06738,1.72168-5.08057,1.9668-1.26318.15088-4.30908.24512-9.1377.28271h-12.77197v-41.47998ZM201.4359,58.85551v9.59229h4.96533c2.95215,0,4.78662-.04688,5.50293-.1416,1.29688-.16992,2.31641-.66504,3.05859-1.48535.74268-.8208,1.11377-1.90039,1.11377-3.23975,0-1.28271-.32031-2.32471-.95996-3.12695-.63965-.80127-1.59131-1.28711-2.854-1.45703-.75098-.09424-2.90918-.1416-6.47559-.1416h-4.35107ZM201.4359,75.35161v11.09131h7.01318c2.72998,0,4.46191-.08496,5.1958-.25439,1.12598-.22656,2.04297-.77832,2.75146-1.65527.70801-.87744,1.06201-2.05176,1.06201-3.52295,0-1.24512-.27295-2.30127-.81885-3.16895-.54639-.86719-1.33545-1.49951-2.36768-1.89551-1.03271-.39648-3.27197-.59424-6.71875-.59424h-6.11719Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M231.68883,93.43169v-41.47998h27.82227v7.01709h-20.24561v9.1958h18.83789v6.98877h-18.83789v11.28955h20.9624v6.98877h-28.53906Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M266.67809,93.43169v-41.47998h15.9458c4.00977,0,6.92334.37305,8.74072,1.11768,1.81738.74561,3.27197,2.07031,4.36426,3.97559,1.0918,1.90527,1.6377,4.08398,1.6377,6.53613,0,3.1123-.82764,5.68262-2.48242,7.70996-1.65527,2.02783-4.12988,3.30615-7.42285,3.83398,1.63818,1.05664,2.99023,2.2168,4.05713,3.48047,1.06592,1.26367,2.50391,3.5083,4.3125,6.73389l4.58154,8.09229h-9.06055l-5.47754-9.02588c-1.94531-3.22559-3.27588-5.25781-3.99268-6.09766-.7168-.83887-1.47607-1.41455-2.27783-1.72607-.80225-.31104-2.07324-.4668-3.81396-.4668h-1.53564v17.31641h-7.57617ZM274.25426,69.49467h5.60547c3.63428,0,5.90381-.16992,6.80811-.50928.9043-.33984,1.61279-.92432,2.12451-1.75439s.76807-1.86768.76807-3.1123c0-1.396-.3374-2.52295-1.01123-3.38135-.67432-.85791-1.62549-1.40039-2.854-1.62695-.61426-.09424-2.45703-.1416-5.52832-.1416h-5.9126v10.52588Z"
        fill="#fff"
        strokeWidth={0}
      />
    </g>
    <g>
      <path
        d="M89.02379,437.14409l7.3457,2.5752c-1.12598,4.52637-2.99902,7.88965-5.61816,10.08691-2.61963,2.19727-5.94238,3.2959-9.96924,3.2959-4.98291,0-9.07812-1.88184-12.28613-5.64453-3.20801-3.76367-4.81152-8.9082-4.81152-15.43457,0-6.9043,1.6123-12.26562,4.8374-16.08594,3.2251-3.81934,7.46484-5.72949,12.7207-5.72949,4.58984,0,8.31836,1.5,11.18506,4.49902,1.70605,1.77344,2.98584,4.31934,3.83936,7.63965l-7.49951,1.98047c-.44385-2.15039-1.36914-3.84766-2.77686-5.09277s-3.11865-1.86816-5.13184-1.86816c-2.78174,0-5.03809,1.10352-6.77002,3.31055s-2.59766,5.78223-2.59766,10.72363c0,5.24414.85303,8.97949,2.55908,11.20508s3.9248,3.33887,6.65479,3.33887c2.01367,0,3.74561-.70801,5.1958-2.12207,1.4502-1.41504,2.49121-3.64062,3.12305-6.67773Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M102.87047,452.39506v-41.48047h27.82227v7.01758h-20.24561v9.19531h18.83789v6.98926h-18.83789v11.28906h20.9624v6.98926h-28.53906Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M139.95641,452.39506v-41.48047h15.9458c4.00977,0,6.92334.37305,8.74072,1.11816s3.27197,2.07031,4.36426,3.97559c1.0918,1.90527,1.6377,4.08398,1.6377,6.53613,0,3.1123-.82764,5.68262-2.48242,7.70996-1.65527,2.02734-4.12988,3.30566-7.42285,3.83398,1.63818,1.05664,2.99023,2.2168,4.05713,3.48047,1.06592,1.26367,2.50391,3.50781,4.3125,6.7334l4.58154,8.09277h-9.06055l-5.47754-9.02637c-1.94531-3.22559-3.27588-5.25781-3.99268-6.09766-.7168-.83887-1.47607-1.41406-2.27783-1.72559-.80225-.31152-2.07324-.4668-3.81396-.4668h-1.53564v17.31641h-7.57617ZM147.53258,428.45756h5.60547c3.63428,0,5.90381-.16992,6.80811-.50879.9043-.33984,1.61279-.9248,2.12451-1.75488s.76807-1.86719.76807-3.1123c0-1.39551-.3374-2.52246-1.01123-3.38086-.67432-.8584-1.62549-1.40039-2.854-1.62695-.61426-.09473-2.45703-.1416-5.52832-.1416h-5.9126v10.52539Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M188.32946,452.39506v-34.46289h-11.13428v-7.01758h29.81885v7.01758h-11.1084v34.46289h-7.57617Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M214.81725,452.39506v-41.48047h7.57617v41.48047h-7.57617Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M232.80748,452.39506v-41.48047h25.72363v7.01758h-18.14746v9.81836h15.66455v7.0166h-15.66455v17.62793h-7.57617Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M265.59459,452.39506v-41.48047h7.57617v41.48047h-7.57617Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M283.53307,452.39506v-41.48047h27.82227v7.01758h-20.24561v9.19531h18.83789v6.98926h-18.83789v11.28906h20.9624v6.98926h-28.53906Z"
        fill="#fff"
        strokeWidth={0}
      />
      <path
        d="M320.56774,410.9146h13.84717c3.12256,0,5.50293.26465,7.14111.79297,2.20117.7168,4.08643,1.99023,5.65625,3.81934,1.56982,1.83008,2.76465,4.07031,3.5835,6.71973.81885,2.65039,1.22852,5.91895,1.22852,9.80469,0,3.41406-.38379,6.35645-1.15186,8.82715-.93848,3.01855-2.27783,5.46094-4.01807,7.3291-1.31445,1.41406-3.08887,2.51758-5.32422,3.31055-1.67236.58496-3.90771.87695-6.70557.87695h-14.25684v-41.48047ZM328.14391,417.93217v27.47363h5.65674c2.11572,0,3.64258-.13184,4.58154-.39551,1.22852-.33984,2.24805-.91504,3.05859-1.72656.81006-.81055,1.47168-2.14551,1.9834-4.00391.51221-1.85742.76807-4.38965.76807-7.59668,0-3.20605-.25586-5.66797-.76807-7.38477-.51172-1.71582-1.22852-3.05566-2.1499-4.01758s-2.09033-1.61328-3.50635-1.95215c-1.05811-.26465-3.13135-.39648-6.21973-.39648h-3.4043Z"
        fill="#fff"
        strokeWidth={0}
      />
    </g>
    <path
      d="M347.24152,199.57566c-21.05921-29.3651-41.81289-35.92841-59.88226-35.92841s-62.11707,15.22302-108.79978,84.86945c-46.68271,69.64643-36.14109,122.89701-36.14109,122.89701,0,0,19.57596-64.92114,91.48216-122.89701,71.90619-57.97587,113.34097-48.94104,113.34097-48.94104Z"
      fill="url(#linear-gradient-3)"
      strokeWidth={0}
    />
  </svg>
);

export default CyberEssentials;
